'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const transitionTimingFunction = "ease-in-out";
const transitionDuration = "300ms";
const transitionValue = `all ${transitionDuration} ${transitionTimingFunction}`;
const Animation = {
  transitionTimingFunction,
  transitionDuration,
  transitionValue
};

exports.Animation = Animation;
//# sourceMappingURL=Animation.cjs.js.map
